import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';

const SarasCssBaseline = ()=>{
    return(
        <CssBaseline/>
    )
}
export default SarasCssBaseline